"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OneSourceConsistentFloor() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="one-source-consistent-floor" className="py-16 md:py-24 bg-card-foreground text-secondary">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-3xl md:text-4xl font-bold font-default mb-6 text-secondary">
          How Does Evermark Keep a Whole Plant Consistent?
        </h2>
        
        <div className="space-y-6 text-lg leading-relaxed mb-8">
          <p>
            Plant-wide identification only works if it is consistent — the same nameplate format on every machine, the same asset-tag scheme across every department, and materials matched to each area of the floor. Evermark Industrial Solutions produces the entire set to one approved format and stores it for reorders, so new equipment and replacements match what is already installed.
          </p>
          <p>
            For asset tracking, Evermark Industrial Solutions produces serialized and barcoded tags to the plant's numbering, so tags reconcile with the CMMS or asset register. Accepted data and barcode formats: {"{{verify: serialization/barcode formats and data inputs e.g. CSV/Excel, 1D/2D}}"}.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
          <Button asChild variant="link" className="px-0 text-primary hover:text-primary/80 text-base font-semibold justify-start h-auto py-1">
            <Link to="#">
              Metal engraving <ArrowRight className="ml-1 size-4" />
            </Link>
          </Button>
          <Button asChild variant="link" className="px-0 text-primary hover:text-primary/80 text-base font-semibold justify-start h-auto py-1">
            <Link to="/LaserEngravingMetalPage">
              Compare all materials <ArrowRight className="ml-1 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}